import React, { createContext, useCallback, useContext, useState } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './DonationPaymentHelpers';
import { shallowEqual, useSelector } from 'react-redux';


const DonationUIContext = createContext();

export function useDonationUIContext() {
    return useContext(DonationUIContext);
}

export const DonationUIConsumer = DonationUIContext.Consumer;

export function DonationUIProvider({ donationUIEvents, children }) {
    const { user } = useSelector(
        (state) => ({ user: state.auth.user }),
        shallowEqual,
    );

    if (user.role === 'MitraEchannel') {
        initialFilter.filter.channel_uuid = user.channel_uuid
    }


    // initialFilter.filter.bank_pooling = donationUIEvents.bankPooling
    initialFilter.filter.bank_account_uuid = donationUIEvents.bankAccount


    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [ids, setIds] = useState([]);
    const setQueryParams = useCallback((nextQueryParams) => {
        setQueryParamsBase((prevQueryParams) => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const [showDonationExportDialog, setShowDonationExportDialog] = useState(false)
    const openDonationExportDialog = () => {
        setShowDonationExportDialog(true)
    }
    const closeDonationExportDialog = () => {
        setShowDonationExportDialog(false)
    }


    const value = {
        queryParams,
        setQueryParamsBase,
        ids,
        setIds,
        setQueryParams,
        newDonationButtonClick: donationUIEvents.newDonationButtonClick,
        openDetailDonationPage: donationUIEvents.openDetailDonationPage,
        filterType: donationUIEvents.filterType,
        openDialogVoid: donationUIEvents.openDialogVoid,
        showDonationExportDialog,
        openDonationExportDialog,
        closeDonationExportDialog,
        addDonationToReconcile: donationUIEvents.addDonationToReconcile,
        removeDonationFromReconcile: donationUIEvents.removeDonationFromReconcile,
        addDonationToReconcileAll: donationUIEvents.addDonationToReconcileAll,
        removeDonationFromReconcileAll: donationUIEvents.removeDonationFromReconcileAll,
        bankAccount: donationUIEvents.bankAccount,
    };

    return (
        <DonationUIContext.Provider value={value}>
            {children}
        </DonationUIContext.Provider>
    );
}
